import { settingsState } from './staticPageSlice';

export const initialState: settingsState = {
  loading: 'idle',
  data: [],
};
